import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@tanstack/react-query';
import { Input, Table } from 'reactstrap';
import Popup from '../../../components/popup/Popup';
import useAxios from '../../../hooks/useAxios';
import FetchStatus from '../../../components/fetchStatus/FetchStatus';
import MyBadge from '../../../components/myBadge/MyBadge';
import DayView from '../../../components/dayView/DayView';
import { AuthContext } from '../../../context/AuthContext';
import { showToast } from '../../../components/toast/Toast';
import PopupConfirmation from '../../../components/popup/PopupConfirmation';

const menus = [
  {
    id: 1,
    label: 'Ringkasan',
    allowedRoles: ['1024'],
  },
  {
    id: 2,
    label: 'Approval',
    allowedRoles: ['1024'],
  },
  {
    id: 3,
    label: 'Rincian Hari',
    allowedRoles: ['1024'],
  },
];

const actionAllowedRole = '4012';

const TimeOffDetail = ({
  selectedData,
  isOpen,
  togglePopup,
  selectedId,
  dateRange,
  totalDayTaken,
  refetch,
  isCheckboxActive,
}) => {
  const { auth } = useContext(AuthContext);
  const [menuActive, setMenuActive] = useState(1);
  const [localDateRange, setLocalDateRange] = useState(dateRange || []);
  const [localTotalDayTaken, setLocalTotalDayTaken] = useState(totalDayTaken || 0);
  const [selectedDays, setSelectedDays] = useState([]);
  const [isSending, setIsSending] = useState(false);
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
  const api = useAxios();

  const { isLoading, error, data } = useQuery({
    queryKey: ['approval-logs', selectedId],
    queryFn: () =>
      api.get(`/module/approval-request/time-off/${selectedId}/logs`).then((res) => {
        return res.data.data;
      }),
  });

  useEffect(() => {
    setLocalDateRange(dateRange || []);
    setLocalTotalDayTaken(totalDayTaken || 0);
  }, [dateRange, totalDayTaken]);

  const handleMenu = (id) => {
    setMenuActive(id);
  };

  const handleSelectedDays = (e) => {
    const { value, checked } = e.target;
    setSelectedDays((prev) => (checked ? [...prev, value] : prev.filter((day) => day !== value)));
  };

  const toggleConfirmation = () => {
    setIsConfirmationOpen(!isConfirmationOpen);
  };

  const handleExcludeDate = () => {
    setIsSending(true);
    api
      .post(`leave/time-off/${selectedId}/exclude-date`, {
        exclude_dates: selectedDays,
      })
      .then((res) => {
        const updatedDateRange = res.data?.data?.date_range || [];
        setLocalDateRange(updatedDateRange);
        setLocalTotalDayTaken(res.data?.data?.total_day_taken || 0);
        refetch();
        setIsSending(false);
        showToast('Rincian hari berhasil diubah', 'success');
        toggleConfirmation();
        setSelectedDays([]);
      })
      .catch((err) => {
        toggleConfirmation();
        setSelectedDays([]);
        setIsSending(false);
        showToast(`Terjadi kesalahan! ${err.response.data.message}`, 'error');
      });
  };

  return (
    <>
      <Popup
        isOpen={isOpen}
        togglePopup={togglePopup}
        title="Detail Pengajuan"
        maxHeight={totalDayTaken > 8 || selectedData?.attachment !== null}
        isOverflow={totalDayTaken > 8 || selectedData?.attachment !== null}
      >
        <div className="d-flex gap-3">
          <div className="d-flex flex-column gap-2" style={{ width: '120px' }}>
            {menus.map(
              (item) =>
                auth?.roles.includes(item.allowedRoles[0]) && (
                  <div
                    key={item.id}
                    onClick={() => handleMenu(item.id)}
                    className={`btn btn-${
                      menuActive === item.id ? 'info' : 'outline-info'
                    } rounded-3 align-items-start d-flex block btn-sm`}
                  >
                    {item.label}
                  </div>
                ),
            )}
          </div>
          <div style={{ width: '85%' }}>
            {menuActive === 1 && (
              <div className="border border-1 rounded-4 p-2">
                <table>
                  <tbody>
                    <tr>
                      <td style={{ verticalAlign: 'top', padding: '3px' }}>Nama Karyawan</td>
                      <td style={{ verticalAlign: 'top', padding: '3px', width: '20px' }}>:</td>
                      <td
                        style={{
                          verticalAlign: 'top',
                          padding: '3px',
                          fontWeight: '500',
                          width: '300px',
                        }}
                      >
                        {selectedData?.employee?.first_name} {selectedData?.employee?.last_name}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ verticalAlign: 'top', padding: '3px' }}>Jenis Cuti</td>
                      <td style={{ verticalAlign: 'top', padding: '3px', width: '20px' }}>:</td>
                      <td style={{ verticalAlign: 'top', padding: '3px', fontWeight: '500' }}>
                        {selectedData?.time_off_master?.type}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ verticalAlign: 'top', padding: '3px' }}>Mulai</td>
                      <td style={{ verticalAlign: 'top', padding: '3px', width: '20px' }}>:</td>
                      <td style={{ verticalAlign: 'top', padding: '3px', fontWeight: '500' }}>
                        <DayView date={selectedData?.date_start} block />
                      </td>
                    </tr>
                    <tr>
                      <td style={{ verticalAlign: 'top', padding: '3px' }}>Berakhir</td>
                      <td style={{ verticalAlign: 'top', padding: '3px', width: '20px' }}>:</td>
                      <td style={{ verticalAlign: 'top', padding: '3px', fontWeight: '500' }}>
                        <DayView date={selectedData?.date_end} block />
                      </td>
                    </tr>
                    <tr>
                      <td style={{ verticalAlign: 'top', padding: '3px' }}>Total Hari</td>
                      <td style={{ verticalAlign: 'top', padding: '3px', width: '20px' }}>:</td>
                      <td style={{ verticalAlign: 'top', padding: '3px', fontWeight: '500' }}>
                        {selectedData?.total_day_taken} Hari
                      </td>
                    </tr>
                    <tr>
                      <td style={{ verticalAlign: 'top', padding: '3px' }}>Alasan Cuti</td>
                      <td style={{ verticalAlign: 'top', padding: '3px', width: '20px' }}>:</td>
                      <td style={{ verticalAlign: 'top', padding: '3px', fontWeight: '500' }}>
                        <i>{`'${selectedData?.reason}'`}</i>
                      </td>
                    </tr>
                    <tr>
                      <td style={{ verticalAlign: 'top', padding: '3px' }}>Lampiran</td>
                      <td style={{ verticalAlign: 'top', padding: '3px', width: '20px' }}>:</td>
                      <td style={{ verticalAlign: 'top', padding: '3px' }}>
                        {selectedData?.attachment !== null ? (
                          <img
                            src={selectedData?.attachment}
                            alt="attachment"
                            width="300"
                            height="auto"
                            className="rounded-4"
                          />
                        ) : (
                          'Tidak ada lampiran.'
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ verticalAlign: 'top', padding: '3px', width: '120px' }}>
                        Diajukan pada
                      </td>
                      <td style={{ verticalAlign: 'top', padding: '3px', width: '20px' }}>:</td>
                      <td style={{ verticalAlign: 'top', padding: '3px', fontWeight: '500' }}>
                        <DayView date={selectedData?.created_at} time block />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            )}

            {menuActive === 2 &&
              (isLoading ? (
                <div style={{ width: '85%' }}>
                  <FetchStatus type="loading" />
                </div>
              ) : error ? (
                <div style={{ width: '85%' }}>
                  <FetchStatus type="error" />
                </div>
              ) : (
                <div className="border border-1 rounded-4 pt-1 pb-2 overflow-hidden">
                  <Table hover responsive>
                    <thead>
                      <tr>
                        <th style={{ minWidth: '30px' }}>#</th>
                        <th style={{ minWidth: '200px' }}>PIC</th>
                        <th style={{ minWidth: '100px' }}>Aksi</th>
                        <th style={{ minWidth: '100px' }} colSpan="2">
                          Status
                        </th>
                        {/* <th style={{ minWidth: '200px' }}>Updated Terakhir</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {data?.map((item) => (
                        <tr key={item.id}>
                          <td style={{ verticalAlign: 'middle' }}>{item.step_order}</td>
                          <td style={{ verticalAlign: 'middle' }}>
                            <div className="d-flex flex-column gap-0">
                              {item.approver_name}
                              <small>{item.approver_position}</small>
                            </div>
                          </td>
                          <td style={{ verticalAlign: 'middle' }}>
                            <MyBadge color="purple">
                              {item.action_type === 'approve'
                                ? 'Menyetujui'
                                : item.action_type === 'verify'
                                ? 'Verifikasi'
                                : 'Mengetahui'}
                            </MyBadge>
                          </td>
                          <td style={{ verticalAlign: 'middle' }}>
                            {item.status === 'pending' && <MyBadge color="blue">Pending</MyBadge>}
                            {item.status === 'approved' && (
                              <MyBadge color="green">Approved</MyBadge>
                            )}
                            {item.status === 'verified' && (
                              <MyBadge color="green">Verified</MyBadge>
                            )}
                            {item.status === 'acknowledged' && (
                              <MyBadge color="green">Confirmed</MyBadge>
                            )}
                            {item.status === 'rejected' && <MyBadge color="red">Rejected</MyBadge>}
                            {item.status === null && <span>-</span>}
                          </td>
                          <td
                            style={{
                              verticalAlign: 'middle',
                              minWidth: item.action_at === null ? '0px' : '180px',
                            }}
                          >
                            {item.action_at === null ? '' : <DayView date={item.action_at} time />}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              ))}

            {menuActive === 3 && (
              <div className="border border-1 rounded-4 pt-1 pb-2 overflow-hidden">
                <Table hover responsive>
                  <tbody>
                    {localDateRange?.map((item) => (
                      <tr key={item.date}>
                        <td style={{ width: '50px', verticalAlign: 'middle' }}>-</td>
                        <td
                          style={{
                            minWidth: '240px',
                            verticalAlign: 'middle',
                            color: `${
                              item.is_weekend || item.is_holiday || item.is_excluded
                                ? '#a2a2a2'
                                : ''
                            }`,
                          }}
                        >
                          {item.date}
                        </td>
                        <td
                          style={{
                            minWidth: '240px',
                            verticalAlign: 'middle',
                            color: `${item.is_weekend || item.is_holiday ? 'blue' : ''}`,
                          }}
                        >
                          {item.is_weekend === false &&
                            item.is_holiday === false &&
                            item.is_excluded === false && (
                              <MyBadge color="blue">Aktif Cuti</MyBadge>
                            )}
                          {item.is_weekend && <MyBadge color="red">Weekend</MyBadge>}{' '}
                          {item.is_holiday && (
                            <MyBadge color="yellow">{item.holiday_description}</MyBadge>
                          )}
                          {item.is_excluded && <MyBadge color="yellow">Dibatalkan</MyBadge>}
                        </td>
                        <td>
                          {auth?.roles.includes(actionAllowedRole) &&
                            item.is_holiday === false &&
                            item.is_weekend === false &&
                            item.is_excluded === false &&
                            isCheckboxActive === true && (
                              <Input
                                type="checkbox"
                                onChange={handleSelectedDays}
                                value={item.date}
                                checked={selectedDays.includes(item.date)}
                              >
                                Tandai
                              </Input>
                            )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
                <div className="d-flex justify-content-between align-items-center px-3">
                  <span>Total: {localTotalDayTaken} hari</span>
                  {auth?.roles.includes(actionAllowedRole) && (
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-danger rounded-3"
                      onClick={toggleConfirmation}
                      disabled={selectedDays.length === 0}
                    >
                      Batalkan hari yang ditandai ({selectedDays.length})
                    </button>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </Popup>
      <PopupConfirmation
        isOpen={isConfirmationOpen}
        loading={isSending}
        toggle={toggleConfirmation}
        handleConfirm={handleExcludeDate}
        btnType="btn-danger"
        title="Konfirmasi"
        message={`Apakah Anda yakin akan membatalkan ${selectedDays.length} hari cuti aktif?`}
      />
    </>
  );
};

TimeOffDetail.propTypes = {
  selectedData: PropTypes.object,
  isOpen: PropTypes.bool,
  togglePopup: PropTypes.func,
  selectedId: PropTypes.number,
  dateRange: PropTypes.array,
  totalDayTaken: PropTypes.number,
  refetch: PropTypes.func,
  isCheckboxActive: PropTypes.bool,
};

export default TimeOffDetail;
